import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: '100%', // Đảm bảo slider chiếm hết chiều rộng container
        margin: '0 auto', // Căn giữa slider nếu cần
    },
    image: {
        display: 'block',
        width: '100%',
        height: 'auto',
    },
}));

const ImageSlider = ({ images }) => {
    const classes = useStyles();

    const settings = {
        dots: true,         // Hiển thị các chấm điều hướng
        infinite: true,     // Lặp lại khi đến cuối
        speed: 500,         // Tốc độ chuyển ảnh (ms)
        slidesToShow: 1,    // Số lượng ảnh hiển thị cùng lúc
        slidesToScroll: 1,  // Số lượng ảnh chuyển khi next/prev
        autoplay: true,     // Tự động chuyển ảnh
        autoplaySpeed: 3000, // Thời gian giữa các lần chuyển ảnh (ms)
        arrows: false,       // Ẩn nút mũi tên next/prev (tùy chọn)
    };

    return (
        <div className={classes.root}>
            <Slider {...settings}>
                {images.map((image, index) => (
                    <div key={index} className={classes.slide}>
                        <img src={image} alt={`Slide ${index + 1}`} className={classes.image} />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default ImageSlider;